<template>
  <v-container class="py-0" fluid>
    <!-- 塾情報フォーム -->
    <v-form
      ref="customer-form"
      :value="customerValid"
      lazy-validation
    >
      <v-request-customer-form/>
    </v-form>

    <v-form
      ref="classroom-form"
      :value="classroomValid"
      lazy-validation
    >
      <!-- 教室情報フォーム -->
      <template v-for="index in classrooms.length">
        <v-request-classroom-form :key="index" :index="index"/>
      </template>
    </v-form>

    <v-row>
      <v-btn class="mt-4 ml-3 mr-4" color="secondary" :disabled="disabledAddClassroom" @click="addClassroom">
        教室追加
      </v-btn>
    </v-row>
    <p class="mb-0 mt-2 attetion">※一度に申し込める教室数は10件までです。</p>
  </v-container>
</template>

<script>
import { mapState, mapMutations, mapGetters } from 'vuex'

import VRequestCustomerForm from '@/components/organizms/RequestCustomerForm'
import VRequestClassroomForm from '@/components/organizms/RequestClassroomForm'

export default {
  components: {
    VRequestCustomerForm,
    VRequestClassroomForm,
  },

  data: () => ({
  }),

  watch: {},

  computed: {
    ...mapState('enrollment', [
      'classrooms',
      'customerValid',
      'classroomValid'
    ]),
    ...mapGetters('enrollment',[
      'disabledAddClassroom'
    ]),
  },

  methods: {
    ...mapMutations('enrollment', [
      'addClassroom',
    ]),
  }
}
</script>

<style lang="stylus" scoped>
  .attetion
    font-size 12px
</style>
